import axios from "../../axios.js";
// * Helpers
import { multiPartData } from "src/helpers/index.js";
const BASE_URL = process.env.REACT_APP_BASE_URL;

// * Function to add news
const addMedia = async (obj) => {
  const { Payload, imageList } = obj;
  console.log("imageList", imageList);
  const formData = multiPartData(Payload);

  [...imageList].forEach((item, i) => {
    formData.append("imageList[]", item);
  });

  const res = await axios.post(`${BASE_URL}/media/admin/add`, formData);
  return res?.data;
};

// ** Function to get all news
const getMedia = async (params) => {
  
  const res = await axios.get(
    `/media/admin/all?search=${params.search}&limit=${params.limit}&sort=${params.sort}&page=${params.page}&countryId=${params.countryId}&eventId=${params.eventId}`
  );
  return res?.data;
};

// ** Function to get news Details
const getNewsById = async (newsId) => {
  const res = await axios.get(`/media/admin/details/${newsId}`);
  return res?.data;
};

// * Function to edit news
const editNews = async (obj) => {
  const { Payload, imageList } = obj;
  const formData = multiPartData(Payload);

  [...imageList].forEach((item, i) => {
    formData.append("imageList[]", item);
  });
  const res = await axios.post(`${BASE_URL}/media/admin/edit`, formData);
  return res?.data;
};

// * Function to delete news
const deleteNews = async (newsId) => {
  const res = await axios.get(`${BASE_URL}/media/admin/delete/${newsId}`);
  return res?.data;
};

// ** Functon to update status of news
const updateNews = async (newsId, Obj) => {
  const res = await axios.post(`${BASE_URL}/media/admin/update/${newsId}`, Obj);
  return res?.data;
};

export { addMedia, editNews, getMedia, deleteNews, getNewsById, updateNews };